module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-expand-md py-0 navbar-light bg-faded sticky-top",
    staticStyle: {
      "background-color": "rgba(227, 242, 253, 0.95)"
    },
    attrs: {
      "id": "header"
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "tag": "a",
      "id": "bname",
      "to": {
        name: 'product',
        params: {
          language: _vm.getLang
        }
      }
    }
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse",
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/AquaWiz_trans_minimum.png"),
      "height": "30",
      "width": "128"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right flex-sm-column",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#collapse-menu",
      "aria-expanded": "false",
      "aria-controls": "collapse-menu"
    },
    on: {
      "click": _vm.expMenu
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "collapse-menu"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-md-row flex-sm-column justify-content-between hidden-lg-up",
    class: _vm.barObj
  }, [_c('ul', {
    staticClass: "navbar-nav nav",
    attrs: {
      "id": "hdr-bar"
    }
  }, [(_vm.checkAuth) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "exact": "",
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.getLang
        }
      }
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language][11]) + " ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "exact": "",
      "to": {
        name: 'home',
        params: {
          language: _vm.getLang
        }
      }
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language][0]) + " ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": {
        name: 'product',
        params: {
          language: _vm.getLang
        }
      }
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v(_vm._s(_vm.nav[_vm.getLang][9]))])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true"
    }
  }, [_vm._v(" Language: " + _vm._s(_vm.nav[_vm.getLang][5]))]), _vm._v(" "), _c('aq-drop-lang')], 1), _vm._v(" "), (_vm.checkAuth) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "exact": "",
      "to": {
        name: 'profile',
        params: {
          language: _vm.getLang
        }
      }
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "24px",
      "height": "20px"
    },
    attrs: {
      "alt": "",
      "src": require("../assets/user.png")
    }
  }), _vm._v(" " + _vm._s(_vm.uname))])]) : _vm._e(), _vm._v(" "), (!_vm.checkAuth) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": {
        name: 'auth',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_vm._v(_vm._s(_vm.nav[_vm.$route.params.language][6]))])]) : _vm._e()], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f380dfb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 345
// module chunks = 0